import { epicRequest } from 'app'

export const DISREGARDED_LIST_FETCH = 'DISREGARDED_LIST_FETCH'
export const DISREGARDED_LIST_FETCH_ERROR = 'DISREGARDED_LIST_FETCH_ERROR'
export const DISREGARDED_LIST_FETCH_FULFILLED = 'DISREGARDED_LIST_FETCH_FULFILLED'
export const DISREGARDED_LIST_FETCH_CANCELED = 'DISREGARDED_LIST_FETCH_CANCELED'

export const DISREGARDED_LIST_INITIAL_STATE = {
  data: [],
  error: null,
  pagination: null,
}

export const disregardedListFetch = () => ({
  payload: {},
  type: DISREGARDED_LIST_FETCH,
})

export const disregardedListFetchFulfilled = (payload) => ({
  payload,
  type: DISREGARDED_LIST_FETCH_FULFILLED,
})

export const disregardedListFetchCanceled = () => ({
  payload: null,
  type: DISREGARDED_LIST_FETCH_CANCELED,
})

export const disregardedListFetchError = (payload) => ({
  payload,
  type: DISREGARDED_LIST_FETCH_ERROR,
})

export const disregardedListFetchEpic = epicRequest({
  actionType: DISREGARDED_LIST_FETCH,
  errorAction: disregardedListFetchError,
  fulfilledAction: disregardedListFetchFulfilled,
  request: 'sports/soccer/matches/disregarded?per_page=100',
  untilTypes: DISREGARDED_LIST_FETCH_CANCELED,
})
